import { Component } from '@angular/core';

@Component({
	templateUrl: '../../../../../../assets/svg/knowledge-bases.svg',
})
export class knowledgeBasesComponent {}
